export class ApplicationError extends Error {
  title: string | undefined;
  notification: string | undefined;

  constructor(message = 'An error has occurred in the Application') {
    super(message);

    this.name = 'ApplicationError';
    this.title = 'application.error.title';
    this.notification = 'application.error.description';

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }

  static fromRuntimeError(error: Error): ApplicationError {
    const applicationError = new ApplicationError(error.message);
    applicationError.name = error.name;
    applicationError.stack = error.stack;
    return applicationError;
  }
}
